module.exports = __webpack_public_path__ + "assets/algoritmo_desktop.4441de86.svg";